import styled from 'styled-components';
import { Flex } from '@cko/primitives';
/**
 * @deprecated - This component is a styled Flex with margin-bottom applied.
 */
export const PageHeader = styled(Flex) `
  margin-bottom: var(--layout-shoe);
`;
